import * as THREE from "three"
import {
  bubbles,
  camera,
  environmentFolder,
  loaders,
  renderer,
  scene,
} from "./Experience"
import MeshReflectorMaterial from "./materials/MeshReflectorMaterial"

export class Environment {
  constructor() {
    this.loadEnvironment()
    this.setEnvironment()
  }

  loadEnvironment() {
    // loaders.gltfLoader.load("/assets/models/Env.gltf", (gltf) => {
    //   this.env = gltf.scene
    //   this.env.traverse((child) => {
    //     if (
    //       child instanceof THREE.Mesh &&
    //       child.material instanceof THREE.MeshStandardMaterial
    //     ) {
    //       child.material.envMap = this.envMap
    //       child.material.envMapIntensity = 0.5
    //     }
    //   })
    //   // scene.add(this.env)
    // })
  }

  setReflectiveFloor() {
    // // this.floor = new THREE.Mesh(new THREE.PlaneGeometry(20, 20))
    // this.floor = new THREE.Mesh(new THREE.CircleGeometry(4, 32))
    // this.floor.rotation.x = -Math.PI / 2
    // this.floor.position.set(0, 0, -2)
    // scene.add(this.floor)
    // this.floor.material = new MeshReflectorMaterial(
    //   renderer.renderer,
    //   camera.camera,
    //   scene,
    //   this.floor,
    //   {
    //     resolution: 1024,
    //     blur: [512, 512],
    //     mixBlur: 1,
    //     mixContrast: 1,
    //     mirror: 1,
    //   }
    // )
    // this.floor.material.setValues({
    //   color: "black",
    //   // normalMap: loaders.textureLoader.load(
    //   //   "/assets/models/concreteNormal.jpg",
    //   //   (texture) => {
    //   //     texture.wrapS = texture.wrapT = THREE.RepeatWrapping
    //   //   }
    //   // ),
    // })
  }

  setEnvironment() {
    // this.envMap = loaders.cubeTextureLoader.load([
    //   "assets/1/px.png",
    //   "assets/1/nx.png",
    //   "assets/1/py.png",
    //   "assets/1/ny.png",
    //   "assets/1/pz.png",
    //   "assets/1/nz.png",
    // ])

    this.crystalEnvMap = loaders.cubeTextureLoader.load([
      "assets/3/px.png",
      "assets/3/nx.png",
      "assets/3/py.png",
      "assets/3/ny.png",
      "assets/3/pz.png",
      "assets/3/nz.png",
    ])
  }
}
